module.exports = __webpack_public_path__ + "media/images/img_mv-e970a36f3782b4109494081889edba55.jpg";